import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
// Multile Select Dropdown
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {
  selectedFeedBackcategor: any = '';
  selectfeedbackTitle: any = ""
  selectFeedbackType: any = '';
  strComments: any = '';
  docTypeList: any = [];
  transactionComment: any = 'feedback'
  wordsTotal: any = 1000;
  restrictedKeywords: any = [];
  isCommentExpand: boolean = false;
  modalReference: any;
  isCommentMandatory: boolean = false;

  constructor(private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private dialog: MatDialog,
    private memorystore: MemoryStorageService) { }

  ngOnInit(): void {

    this.restrictedKeywords = this.commonService.getRestrictedKeywords();
    this.getDropDownCategoryBinding()

  }
  getDropDownCategoryBinding() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    this.dataService.getData('settings/getfeedbackcategory', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res != null && res.data != null) {
            this.docTypeList = [];

            res.data.forEach((element) => {
              this.docTypeList.push({
                value: element.VALUE,
                text: element.TEXT
              });
            });
          }
          this.selectedFeedBackcategor = this.docTypeList[0].value;
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        this.commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      }
    );
  }

  checkRestrictedKeywords(formControlName: string) {
    let foundedRestrictedKeyword = [];
    var input = this.strComments;
    this.restrictedKeywords.forEach((keyword) => {
      if (input.includes(keyword.restrict)) {
        input = this.replaceAll(input, keyword.restrict, keyword.replace);
        foundedRestrictedKeyword.push(keyword.restrict);
      }
    });
    if (foundedRestrictedKeyword.length > 0) {
      this.strComments = input;
      this.commonService.showMessageBox(
        'We found some restricted keyword(s) entered in Comment.<br>It auto replaced by replacement keywords.<br>Please check given link for restricted keywords.',
        'Warning'
      );
    }
  }

  function(data) {
    this.wordsTotal = this.wordsTotal - data.length
  }

  replaceAll(str, find, replace) {
    var escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    return str.replace(new RegExp(escapedFind, 'g'), replace);
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  saveData() {

    let invalidSubmitMsg = '';
    let isSubmitValid = true;

    if (this.selectedFeedBackcategor == '' || this.selectedFeedBackcategor == undefined || this.selectedFeedBackcategor == null) {
      invalidSubmitMsg += 'Please select FeedBack category\r <br/>';
    }
    if (this.selectfeedbackTitle == '' || this.selectfeedbackTitle == undefined || this.selectfeedbackTitle == null) {
      invalidSubmitMsg += 'Please give Title\r <br/>';
    }

    if (this.strComments == '' || this.strComments == undefined || this.strComments == null) {
      invalidSubmitMsg += 'Comments is missing\r <br/>';
    }

    if (this.selectFeedbackType == '' || this.selectFeedbackType == undefined || this.selectFeedbackType == null) {
      invalidSubmitMsg += 'Please select FeedbackType  <br/>';
    }
    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');

    }
    else {
      let obj = {
        application: "PI",
        feedback_category_id: this.selectedFeedBackcategor,
        feedback_title: this.selectfeedbackTitle,
        feedback_comments: this.strComments,
        feedback_type: this.selectFeedbackType,
        // createdby: this.commonService.getUserInfoFromLocalStorage('userId')
        createdby: this.memorystore.getItem('userId')
      }
      this.dataService.postData("settings/insertfeedbackdata", obj, this.dataService.apiURL_Core).subscribe(res => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status == true) {
            //this.commonService.showMessageBox("Feedback recorded sucessfully", "Alert");
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
              disableClose: true,
              data: {
                title: "Alert",
                message: "Feedback recorded successfully",
                messageBoxType: 'ok'
              },
            });
            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
              if (confirmed) {
                this.ResetData();
              } else {
              }
            });
          }
          else {
            this.commonService.showMessageBox(res.error_message, "Alert");
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
        error => {
          this.commonService.showMessageBox(error.toString());
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }

  ResetData() {
    this.selectfeedbackTitle = '';
    this.strComments = ''
    this.selectFeedbackType = ''
    this.getDropDownCategoryBinding();
  }
}
